import { File, FileText } from "lucide-react";

/**
 * A document's mark at the start of its row: a page, banded with "PDF" in red
 * for a PDF as v0.28 marks one, and the plain page for any other format. The
 * band is the format named, so a reader hears it; the plain page says nothing
 * the row's own words do not.
 */
export function FileMark({ contentType }: { contentType: string }) {
  if (contentType !== "application/pdf") {
    return (
      <FileText
        aria-hidden
        className="size-5 flex-none text-muted-foreground"
      />
    );
  }
  return (
    <span
      role="img"
      aria-label="PDF"
      className="relative grid size-[26px] flex-none place-items-center text-subtle-foreground"
    >
      <File aria-hidden strokeWidth={1.2} className="size-[26px]" />
      <span
        aria-hidden
        className="absolute bottom-[4px] left-[1px] rounded-[2px] bg-destructive px-[3px] text-[6.5px] leading-[8px] font-bold tracking-[0.02em] text-white"
      >
        PDF
      </span>
    </span>
  );
}
